var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconWrittencontact30 = function SvgAIconWrittencontact30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7685 25.9749H4.75369C3.78515 25.9749 3 25.1836 3 24.2076V4.7673C3 3.79125 3.78515 3 4.75369 3H22.4053C23.3738 3 24.1611 3.79125 24.1611 4.7673V15.7201",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8L19 8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13L19 13",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22949 18H12.2985",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21C16 20.4477 16.4477 20 17 20H28C28.5523 20 29 20.4477 29 21V28C29 28.5523 28.5523 29 28 29H17C16.4477 29 16 28.5523 16 28V21Z",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5049 24.8214L26.5784 26.6299",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4953 24.8214L18.4219 26.6299",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6171 20.2948L23.2821 25.8359C22.8111 26.162 22.1881 26.162 21.7171 25.8359L16.3818 20.2948",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconWrittencontact30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xMS43Njg1IDI1Ljk3NDlINC43NTM2OUMzLjc4NTE1IDI1Ljk3NDkgMyAyNS4xODM2IDMgMjQuMjA3NlY0Ljc2NzNDMyAzLjc5MTI1IDMuNzg1MTUgMyA0Ljc1MzY5IDNIMjIuNDA1M0MyMy4zNzM4IDMgMjQuMTYxMSAzLjc5MTI1IDI0LjE2MTEgNC43NjczVjE1LjcyMDEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik03IDhMMTkgOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTcgMTNMMTkgMTMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik03LjIyOTQ5IDE4SDEyLjI5ODUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYgMjFDMTYgMjAuNDQ3NyAxNi40NDc3IDIwIDE3IDIwSDI4QzI4LjU1MjMgMjAgMjkgMjAuNDQ3NyAyOSAyMVYyOEMyOSAyOC41NTIzIDI4LjU1MjMgMjkgMjggMjlIMTdDMTYuNDQ3NyAyOSAxNiAyOC41NTIzIDE2IDI4VjIxWiIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTI0LjUwNDkgMjQuODIxNEwyNi41Nzg0IDI2LjYyOTkiIHN0cm9rZS13aWR0aD0iMS40IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0yMC40OTUzIDI0LjgyMTRMMTguNDIxOSAyNi42Mjk5IiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMjguNjE3MSAyMC4yOTQ4TDIzLjI4MjEgMjUuODM1OUMyMi44MTExIDI2LjE2MiAyMi4xODgxIDI2LjE2MiAyMS43MTcxIDI1LjgzNTlMMTYuMzgxOCAyMC4yOTQ4IiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4=";